export default ( ) => {
    return (
        <div className="page-loader">
            <div className="bar"></div>
        </div>
    )
}